import { sha256 } from 'js-sha256';

export const encryptSha256 = (input: string) => {
  // @ts-ignore
  return sha256(String(input));
};

export default encryptSha256;
